import { Component, OnInit, Inject, OnDestroy, HostListener } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ISiteRequestProxyMembers, ISiteRequestDetails } from '../../models/request';
import { proxyRequestMembersSelector } from 'src/app/app-store/site-request/site-request.selector';
import { DeleteProxyRequestMembersAction } from 'src/app/app-store/site-request/site-request.action';
import jsPDF from 'jspdf';
import { QrCodedialogComponent } from '../qr-codedialog/qr-codedialog.component';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { SiterequestService } from 'src/app/core/services/siterequest.service';
import { InfoDialogueComponent } from 'src/app/shared/dialogues/infodialog/infodialog.component';

@Component({
  selector: 'app-crewdetailsdialog',
  templateUrl: './crewdetailsdialog.component.html',
  styleUrls: ['./crewdetailsdialog.component.css']
})
export class CrewdetailsdialogComponent implements OnInit, OnDestroy {

  cssclass: string;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    if (window.innerHeight >= 320 && window.innerHeight <= 700) {
      this.cssclass = 'site-view-port3';
    } else {
      this.cssclass = 'site-view-port1';
    }
  }

  name: string;
  jobTitle: string;
  proxyRequestMember?: ISiteRequestProxyMembers[];
  showDelete: boolean;
  requestDetailsSubscription: Subscription;
  selectedRequest: ISiteRequestDetails;
  show: boolean;
  showRequestQR: boolean;
  showApproveQR: boolean;

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<CrewdetailsdialogComponent>,
    private dialog: MatDialog,
    private infoDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siterequestService: SiterequestService
  ) {

  }

  ngOnInit() {
    this.getScreenSize();
    // console.log(this.data)
    if (this.data?.length === 0) {
      this.store.pipe(select(proxyRequestMembersSelector)).subscribe(response => {
        if (response !== undefined) {
          this.proxyRequestMember = response;
          this.showDelete = true;
        }
      });

    } else {
      this.proxyRequestMember = this.data.siteRequestProxyMembers;
      this.showDelete = false;
      this.selectedRequest = this.data;
      if (this.data.approverRequestStatusId === 2 && this.data.requestStatusId === 2) {
        this.showApproveQR = true;

      } else if (this.data.approverRequestStatusId === 0 && this.data.requestStatusId === 2) {
        this.showRequestQR = true;
      } else {
        this.showApproveQR = false;
        this.showRequestQR = false;
      }
    }

  }

  delete = (alias: string, phone: string) => {
    this.store.dispatch(DeleteProxyRequestMembersAction({ alias: alias, phone: phone }));
  }


  getQRCode(user, qrCode) {
    this.show = true;
    this.siterequestService.getSiteRequestQRCodeCrewDetails(this.selectedRequest.id, user.id).subscribe(response => {
      if (response.message) {
        this.openInfoDialog(response.message);
        this.show = false;

      } else {
        if (response.payload) {
          if (qrCode === 'view') {
            this.show = false;
            this.openQRCodeDialog(response.payload);
          } else if (qrCode === 'download') {
            this.show = false;
            this.downloadQRCode(user, response.payload);
          }
        }
      }
    });
  }


  openInfoDialog(message): void {
    const dialogRef = this.infoDialog.open(InfoDialogueComponent, {
      minWidth: '30vw',
      data: { status: message, isValid: undefined },
      disableClose: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      dialogRef.close();
    });
  }

  downloadQRCode(user, qrCode) {
    const doc = new jsPDF('p', 'pt', 'a4', true);

    doc.setFontSize(20);
    doc.setFont('Verdana');
    doc.setFontType('bold');

    doc.setTextColor(10);
    doc.text('ONE SITE PASS', 20, 50);
    doc.setTextColor(150);
    doc.text('QR CODE ACCESS', 400, 50);

    doc.setFontSize(15);
    doc.setFont('Verdana');
    doc.setFontType('normal');

    doc.setTextColor(150);
    doc.text('Request ID', 30, 100);
    doc.setTextColor(10);
    doc.text('' + this.selectedRequest?.id, 30, 120);


    doc.setTextColor(150);
    doc.text('Facility', 30, 150);
    doc.setTextColor(10);
    doc.text('' + this.selectedRequest?.facilityName, 30, 170);


    doc.setTextColor(150);
    doc.text('Name', 30, 200);
    doc.setTextColor(10);
    doc.text('' + user?.name, 30, 220);

    doc.setTextColor(150);
    doc.text('GIN', 30, 250);
    doc.setTextColor(10);
    if (user.gin === undefined || user.gin === '') {
      doc.text('' + 'N/A', 30, 270);
    } else {
      doc.text('' + user?.gin, 30, 270);
    }

    doc.setTextColor(150);
    doc.text('QR Validity', 30, 300);
    doc.setTextColor(10);
    doc.text('' + moment(this.selectedRequest?.siteRequestDuration.startDate).format('DD MMM YYYY') + ' - ' + moment(this.selectedRequest?.siteRequestDuration.endDate).format('DD MMM YYYY'), 30, 320);

    doc.setTextColor(150);
    doc.text('Requested By', 30, 350);
    doc.setTextColor(10);
    doc.text('' + this.selectedRequest?.name, 30, 370);

    doc.setFontSize(15);
    doc.setTextColor(150);
    doc.text('Scan QR to Check In/ Check Out', 150, 400);

    doc.addImage(qrCode, 'PNG', 150, 420, 300, 300, '', 'FAST');

    doc.setFontSize(10);
    doc.setTextColor(150);
    doc.text('All Rights Reserved Schlumberger 2020', 225, 800);

    doc.save('RQ ID-' + this.selectedRequest.id + ' ' + user?.name + '.pdf');
  }

  openQRCodeDialog(qrCode) {
    const data = {
      qrCode
    };
    this.dialog.open(QrCodedialogComponent, {
      maxHeight: '100vh',
      maxWidth: '40vh',
      panelClass: 'custom-dialog-container',
      data
    });
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.requestDetailsSubscription) {
      this.requestDetailsSubscription.unsubscribe();
    }
  }
}
